import axios from 'axios';
export const baseurl = "https://mugemsapi.lifecode.co.in/api/v1/";
export const imageurl = "https://mugemsapi.lifecode.co.in/api/v1/";
export const projectNo = 'MUJems'

// Base configuration
const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || baseurl,
    timeout: 300000, // Optional: Set a timeout for requests
});

// Request interceptor for adding headers
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token'); // Replace with your token retrieval logic
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle specific error responses like 401 Unauthorized
        if (error.response?.status === 401) {
            // console.error('Unauthorized, logging out...');
            // Add your logout logic here, e.g., clearing tokens, redirecting to login
        }
        return Promise.reject(error);
    }
);

// Generic GET request
export const get = async (url, params = {}, config = {}) => {
    try {
        const token = localStorage.getItem('token');
        let updatedConfig = {
            ...config,
            headers: {
                ...config.headers,
            },
        };

        if (token) {
            updatedConfig.headers.Authorization = `Bearer ${token}`;
        }

        const response = await apiClient.get(url, { ...updatedConfig, params });
        return response.data;
    } catch (error) {
        // console.error(`GET ${url} failed:`, error);
        throw error;
    }
};


// Generic POST request
export const post = async (url, data = {}, config = {}) => {
    try {
        // Ensure the Authorization header exists
        const token = localStorage.getItem('token'); // Replace with your token retrieval logic

        // Update config with Authorization and Content-Type headers
        const updatedConfig = {
            ...config,
            headers: {
                ...config.headers,
                Authorization: token ? `Bearer ${token}` : undefined,
            },
        };

        const response = await apiClient.post(url, data, updatedConfig);

        return response.data; // Return only the data
    } catch (error) {
        // console.error(`POST ${url} failed:`, error);

        // Handle specific cases of failed authorization
        if (error.response?.status === 401) {
            // console.error('Authorization failed. Redirecting to login.');
            // Redirect to login or perform token refresh logic here
        }
        throw error;
    }
};


// Add more methods (PUT, DELETE) if needed
export const put = async (url, data = {}, config = {}) => {
    try {
        const response = await apiClient.put(url, data, config);
        return response.data;
    } catch (error) {
        // console.error(`PUT ${url} failed:`, error);
        throw error;
    }
};

export const del = async (url, config = {}) => {
    try {
        const response = await apiClient.delete(url, config);
        return response.data;
    } catch (error) {
        // console.error(`DELETE ${url} failed:`, error);
        throw error;
    }
};
